import React, { Component } from "react";
import { Page } from "pages/page";
import { faDiscord } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./index.module.scss";

class Discord extends Component {
	public readonly inviteURL = "https://discord.com/invite/HSeycPx";

	public render (): JSX.Element {
		return <div className={ styles.wrapper }>
			<div className={ styles.intro }>
				<p>We have a Discord server to help us archiving everything.</p>
				<p>If there is a game you can't find here, you can always come and ask us directly!</p>
				<p>All you need is a Discord account, and we'll happily meet you:</p>
			</div>
			<div className={ styles.cards }>
				<a
					href={ this.inviteURL }
					className={ styles.card }
					target="_blank"
					rel="noopener noreferrer"
				>
					<span className={ `${ styles.icon } ${ styles.discordIcon }` }>
						<FontAwesomeIcon icon={ faDiscord } />
					</span>
					<span className={ styles.label }>Join us</span>
				</a>
			</div>
			<p className={ styles.note }>(pssst: we even have a bot for finding fangames quicker)</p>
		</div>;
	}
}

const page = new Page({
	name: "Discord",
	content: <Discord />,
	icon: faDiscord,
});

export default page;
